import { Box } from 'shared';
import styled, { to } from 'theme';

const selectPrefix = '.select';

export const PortalWrapper = styled(Box)`
  background-color: ${props => props.theme.variables.customColors.backgroundColor};
  margin-bottom: 0;
  height: 100%;
  box-shadow: inset 0 1rem 1rem -1rem rgba(0, 0, 0, 0.1);

  .menu__placement--top {
    ${to('md')} {
      ${selectPrefix}__menu {
        bottom: 0;
        top: auto;
        margin-bottom: 0;
        position: absolute;
      }

      ${selectPrefix}__menu-list {
        height: 40vh;
        padding-bottom: 0;
      }

      ${selectPrefix}__close-menu {
        position: inherit;
      }
    }
  }
`;
